import React, { useState, useContext } from "react";
import { AuthContext } from "./Admin";
import { api } from "../../api";

const Login = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");
    const { login } = useContext(AuthContext);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError("");

        try {
            const formData = new FormData();
            formData.append("username", username);
            formData.append("password", password);

            const response = await api.post("/cms/token", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            if (response.data && response.data.access_token) {
                login(response.data.access_token);
            } else {
                setError("Invalid response from server");
            }
        } catch (err) {
            console.error("Login error:", err);
            setError(
                err.response?.data?.detail ||
                    "Failed to login. Please try again."
            );
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="login-container">
            <h1>Ellington CMS</h1>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="username">Username</label>
                    <input
                        type="text"
                        id="username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="password">Password</label>
                    <input
                        type="password"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </div>
                <button
                    type="submit"
                    className="login-btn"
                    disabled={isLoading || !username || !password}
                >
                    {isLoading ? "Logging in..." : "Login"}
                </button>
                {error && <div className="error-message">{error}</div>}
            </form>
        </div>
    );
};

export default Login;
